import React, { useState, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import { NavLink } from "react-router-dom";
import { Text18Size, TitleH2, StyledButton } from "components/generic";
// import {  } from "../generic";
import {
  ItemLink,
  LimitWidthSection,
} from "../styles";
import { BlogGrid, JobDiv, JobTitle, JobSection, JobImg, ButtonSection } from "./styles";

import { CardVacancies } from "./CardVacancies";
import { HeaderSEO } from "components/headerSEO";
import { ISeo } from "interfaces/intarfaces";
import mainImg from "assets/images/jobs_img.png";

// This number need to change when added new posts
const amountPosts = 4;



export const Vacancies: React.FC = () => {
  const { t, i18n } = useTranslation('vacancies');

  const [posts, setPosts] = useState<string[]>([]);

  useEffect(() => {
    const vacanciesPosts: string[] = Array(amountPosts)
      .fill("post")
      .map((_, index) => "post" + (index + 1))
      .reverse();
    setPosts(vacanciesPosts);
  }, [i18n.language]);

  const seo = t("vacancies.seo", { returnObjects: true }) as ISeo;

  return (
    <JobDiv>
      <JobSection>
        {seo && <HeaderSEO {...seo} />}
        <JobTitle>{t("vacancies.title")}</JobTitle>
        <JobImg src={mainImg} />
        <TitleH2>{t("vacancies.looking")}</TitleH2>
        <BlogGrid>
          {posts.length &&
            posts.map((item, j) => <CardVacancies keyPost={item} key={j} />)}
        </BlogGrid>
        <TitleH2>{t("vacancies.about")}</TitleH2>
        <LimitWidthSection>
          <Text18Size>{t("vacancies.text.0")}</Text18Size>
          <ButtonSection>
            <StyledButton >
              <NavLink to={`/${i18n.language}/mission`}>
                {t('vacancies.buttons.mission')}
              </NavLink>
            </StyledButton>
            <StyledButton >
              <NavLink to={`/${i18n.language}/team`}>
                {t('vacancies.buttons.team')}
              </NavLink>
            </StyledButton>
          </ButtonSection>
        </LimitWidthSection>
      </JobSection>
    </JobDiv>
  );
};
